export const LIFECYCLE_LABELS = {
  draft: "草稿",
  pending_review: "待审核",
  approved_sandbox: "沙箱可用",
  verifying: "验收中",
  live: "已上线",
  suspended: "已停用",
  rejected: "已驳回",
};

export const TENANT_KIND_LABELS = {
  platform_mall: "平台店",
  plugin: "私域插件",
  dist_enterprise: "分销企业",
};

export const STATUS_LABELS = {
  pending: "待审核",
  approved: "已通过",
  rejected: "已驳回",
  verified: "已验收",
  draft: "草稿",
};

export const ENV_LABELS = {
  sandbox: "沙箱环境",
  live: "生产环境",
};

export const OVERVIEW_HINTS = {
  lifecycle: "商家在平台的入驻与上线阶段；影响可用能力与密钥类型。",
  tenant_kind: "接入身份：平台店、私域插件或分销企业，决定能力配置与验收清单。",
  env: "服务端认定的环境：未验收上线前为沙箱；验收通过后为生产。",
  status: "后台审核状态字段，与生命周期徽章相互对照。",
};

export const CHECKLIST_HINTS = {
  size_chart: "至少绑定一套可用尺码表，供荐码与试穿引用。",
  catalog_visible: "商家写入的商品需出现在 C 端可浏览货盘。",
  shop_profile: "店铺资料完整且 shop_code 可被解析访问。",
  recommend_smoke: "完成一次荐码或试穿接口冒烟，证明链路可用。",
  plugin_ledger: "私域插件台账行已创建，用于域名与回调绑定。",
  origin_whitelist: "配置并校验允许嵌入 Widget 的站点域名。",
  widget_smoke: "宿主页可成功创建试穿会话。",
  product_register: "至少登记一个 SKU 及对应尺码表。",
  event_callback: "配置事件回调 URL，用于接收试穿/荐码结果。",
  order_callback_smoke: "订单回传链路冒烟，含 recommend_task_id。",
  product: "至少发布一个可售 SKU。",
  size_mapping: "尺码组件或平台映射推送已完成联调。",
};

export const CHECKLIST_LABEL_CN = {
  size_chart: "已录入尺码表",
  catalog_visible: "货盘已贯通至 C 端",
  shop_profile: "店铺资料完整且可访问",
  recommend_smoke: "荐码/试穿冒烟已通过",
  plugin_ledger: "插件台账已建立",
  origin_whitelist: "域名白名单已配置并通过校验",
  widget_smoke: "嵌入试穿会话可建",
  product_register: "至少登记 1 个 SKU 与尺码表",
  product_register_dist: "分销下发包可达",
  event_callback: "事件回调地址已配置",
  order_callback_smoke: "订单回传冒烟已通过",
  product: "至少发布 1 个 SKU",
  size_mapping: "尺码组件或平台映射推送已完成",
};

export const STEPS = [
  { id: "register", label: "注册" },
  { id: "approved_sandbox", label: "沙箱" },
  { id: "verifying", label: "提交验收" },
  { id: "live", label: "上线" },
];

export const PROVIDER_HINT = {
  wechat: "请使用微信扫一扫",
  alipay: "请使用支付宝扫一扫",
};

export function labelTenantKind(v) {
  return TENANT_KIND_LABELS[v] || v || "—";
}

export function labelEnv(v) {
  return ENV_LABELS[v] || (v === "live" ? "生产环境" : v === "sandbox" ? "沙箱环境" : v || "—");
}

export function labelStatus(v) {
  return STATUS_LABELS[v] || LIFECYCLE_LABELS[v] || v || "—";
}

export function checklistLabel(it, tenantKind) {
  if (it.id === "product_register" && tenantKind === "dist_enterprise") {
    return CHECKLIST_LABEL_CN.product_register_dist;
  }
  return CHECKLIST_LABEL_CN[it.id] || it.label || it.id || "—";
}
